// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-components-receipt-previews-Total-__Total___2DLF8","receipt-total-box":"app-components-receipt-previews-Total-__Total___2aoks","receipt-cash-box":"app-components-receipt-previews-Total-__Total___aSzQA","receipt-change-box":"app-components-receipt-previews-Total-__Total___2sDpd"};


//////////////////
// WEBPACK FOOTER
// ./app/components/receipt/previews/Total/Total.css
// module id = 2238
// module chunks = 0